import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from "@angular/forms";
import {CampanhasService} from "../../service/campanhas/campanhas.service";
import {ToastrService} from "ngx-toastr";
import {CampanhasFormDto} from "./campanhasForm.dto";
import {CampanhasDto} from "./campanhas.dto";
import {AlterarCampanhaFormDto} from "./alterarCampanhaForm.dto";
import {ModalComponent} from "../modal/modal.component";
import {MatDialog} from "@angular/material/dialog";
import {ModalEdicaoCampanhaComponent} from "./modalEdicao/modal-edicao-campanha.component";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import { MAT_DATE_FORMATS } from '@angular/material/core';

@Component({
  selector: 'app-campanhas',
  templateUrl: './campanhas.component.html',
  styleUrls: ['./campanhas.component.sass'],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: ['l', 'LL'],
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    }
  ]
})
export class CampanhasComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  displayedColumns: string[] = ['tipoCampanha', 'ano', 'PeriodoAtivo', 'acoes'];
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('paginator') paginator: MatPaginator;
  dataSource: MatTableDataSource<CampanhasDto>;
  totalElements: number = 0;
  anoPesquisa: number = 0;
  tipoCampanhaPesquisa: number = 0;
  pageSize: number = 5;


  caracteresRestantes: number = 2000;
  limiteAtingido: boolean = false;

  constructor(private formBuilder: FormBuilder,
              private camapanhaService: CampanhasService,
              private toasterService: ToastrService,
              public dialog: MatDialog) { }

  ngAfterViewInit() {
    this.getCampanhas(0, this.pageSize);
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.form = this.formBuilder.group({
      tipoCampanha: ["", Validators.required],
      ano: ["", [Validators.required, Validators.pattern("^[2][0-9][0-9][0-9]+$")]],
      dataInicio: ["", Validators.required],
      dataFim: ["", Validators.required],
      referenciaInicio: ["", Validators.required],
      referenciaFim: ["", Validators.required],
      observacao: ["", Validators.required]
    });
  }

  private getCampanhas(pagina: number, size: number, ano: number = 0, tipoCamapnha: number = 0) {
    this.camapanhaService.getCampanhas(pagina, size, ano, tipoCamapnha).subscribe( resp =>{
      this.dataSource = new MatTableDataSource(resp.content);
      this.totalElements = resp.totalElements;
      //this.dataSource.paginator = this.paginator;
      /*this.dataSource = resp.content;*/
    })
  }

  cadastrarCampanha(formDirective: FormGroupDirective) {

    let obj: CampanhasFormDto = null;
    obj = this.form.getRawValue();

    if(obj.dataFim<obj.dataInicio || obj.referenciaFim<obj.referenciaInicio){
      this.toasterService.error("Data Fim menor que data Inicio")
    } else{
      if(this.form.valid){
        this.camapanhaService.salvarCampanha(this.form.getRawValue()).subscribe( resp => {
          this.getCampanhas(0, this.pageSize, this.anoPesquisa, this.tipoCampanhaPesquisa);
          formDirective.resetForm();
          this.form.reset();
          this.toasterService.success("Campanha cadastrada com sucesso!");
        }, error => {
          this.toasterService.error(error.error.message);
        });
      }
    }

  }

  deleteItem(element: CampanhasDto) {
    this.camapanhaService.deletarCampanha(element.id).subscribe( resp => {
      this.getCampanhas(0,this.pageSize, this.anoPesquisa, this.tipoCampanhaPesquisa)
      this.toasterService.success("Campanha deletada.");
    }, error => {
      this.toasterService.error(error.error.message);
    })
  }

  deleteItemTable(element: CampanhasDto){
    this.dataSource.data = this.dataSource.data.filter(
        row => element != row
    );
  }

  editarItem(element: CampanhasDto) {
    this.openDialog(element)
  }

  atualizarCampanha(campanha: AlterarCampanhaFormDto){
    this.camapanhaService.atualizarCampanha(campanha, campanha.id).subscribe( resp => {
      this.toasterService.success("Campanha atualizada com sucesso!");
      this.getCampanhas(0, this.pageSize, this.anoPesquisa, this.tipoCampanhaPesquisa);
    }, err => {
      this.toasterService.error(err.error.message);
    })
  }

  openDialog(campanha: CampanhasDto): void {
    this.dialog.open(ModalEdicaoCampanhaComponent, {
      width: '450px',
      data: {
        header: 'Editar Período Ativo',
        campanha: campanha,
        labelOne: 'Voltar',
        labelTwo: 'Salvar',
        action: (campanhaAlterada: AlterarCampanhaFormDto) => {
            this.atualizarCampanha(campanhaAlterada);
        }
      }
    });
  }

  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

  nextPage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.getCampanhas(event.pageIndex, event.pageSize, this.anoPesquisa, this.tipoCampanhaPesquisa);
  }

  pesquisa(event: any) {
    this.anoPesquisa = event.target.value;
    if(this.anoPesquisa.toString().length>3){
      this.getCampanhas(0, this.pageSize, this.anoPesquisa, this.tipoCampanhaPesquisa);
    }
  }

  pesquisaTipo($event: any) {
    this.tipoCampanhaPesquisa = $event.source.value;
    this.getCampanhas(0, this.pageSize, this.anoPesquisa, this.tipoCampanhaPesquisa);
  }
  atualizarContagem() {
    const maxCaracteres = 2000;
    const observacao = this.form.get('observacao').value;
    this.caracteresRestantes = maxCaracteres - observacao.length;

    if (this.caracteresRestantes < 0) {
      this.form.get('observacao').setValue(observacao.slice(0, maxCaracteres));
      this.caracteresRestantes = 0;
    }
  }

}
